import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import { VERSION_TO_MIGRATE_TO } from '../../helpers';


const STEPS = {
  FIRST: 1,
  SECOND: 2,
  THIRD: 3,
  FOURTH: 4,
};

export default {
  mixins: [
    loaderMixin,
  ],
  data() {
    return {
      STEPS,
    };
  },
  computed: {
    ...mapState('whatisnew', ['currentStepIndexFlow1', 'optionSecondStepSelectedFlow1', 'optionThirdStepSelectedFlow1']),
    isFirstStep() {
      return this.currentStepIndexFlow1 === STEPS.FIRST;
    },
    isLastStep() {
      return this.currentStepIndexFlow1 === STEPS.FOURTH;
    },
  },
  methods: {
    ...mapActions('app', ['setSettingColorPalette', 'setSettingMobileLayout', 'setSettingsAnnouncementCurState']),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('whatisnew', ['nextStepFlow1', 'prevStepFlow1']),
    onPreviousStep() {
      this.prevStepFlow1();
    },
    onNextStep() {
      if (this.currentStepIndexFlow1 === this.STEPS.FIRST) {
        this.nextStepFlow1();
      } else if (this.currentStepIndexFlow1 === this.STEPS.SECOND) {
        this.loaderAdd(document.body);
        this.setSettingColorPalette(this.optionSecondStepSelectedFlow1)
          .then(() => {
            this.loaderRemove(document.body);
            this.nextStepFlow1();
          })
          .catch(() => this.loaderRemove(document.body));
      } else if (this.currentStepIndexFlow1 === this.STEPS.THIRD) {
        this.loaderAdd(document.body);
        this.setSettingMobileLayout(this.optionThirdStepSelectedFlow1)
          .then(() => {
            this.loaderRemove(document.body);
            this.nextStepFlow1();
          })
          .catch(() => this.loaderRemove(document.body));
      } else if (this.currentStepIndexFlow1 === this.STEPS.FOURTH) {
        this.loaderAdd(document.body);
        this.setSettingsAnnouncementCurState(VERSION_TO_MIGRATE_TO)
          .then(() => {
            this.loaderRemove(document.body);
            this.setCurrentPopup();
          })
          .catch(() => this.loaderRemove(document.body));
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/what-is-new-popup/flows/what-is-new-flow-version-1/mixin.js